import React from "react";
import { DRIVE_TAB } from "@/utils/constants/tabConstants";
import { Tooltip, FilterValue } from "../../components";
import { MediaModel } from "@/database";
import { mediaStatusToTextAndColor, mediaStatusTooltipText } from "../../utils";
import {
  renderStatusBadge,
  renderCopyIdSection,
} from "@/utils/utilFunctions/commmonFunctions";
import { MEDIA_STATUS } from "@/utils/constants/uiConstants";
import FilterButton from "@/utils/ui/FilterButton";
import { Display_Value_Key as dvk } from "@/components/Create/utils";
import styles from "../../scss/media.module.scss";

interface RenderStatusProps {
  media: MediaModel;
  activeType: string;
  filters: Record<string, FilterValue>;
  updateIsFilter: (isFilter: boolean) => void;
  updateIsClearFilter: (isClearFilter: boolean) => void;
  handleSetFilters: (filters: Record<string, FilterValue>) => void;
}

const RenderStatus: React.FC<RenderStatusProps> = ({
  media,
  activeType,
  filters,
  updateIsFilter,
  updateIsClearFilter,
  handleSetFilters,
}) => {
  const statusInfo = mediaStatusToTextAndColor(media?.media_status || 0);

  if ((media as any)?.archive === 1) {
    return (
      <div className={`d-flex align-items-center mt-2 ${styles["hover-filter"]}`}>
        <Tooltip content="Inactive">
          <div className="badge bg-info">Inactive</div>
        </Tooltip>
      </div>
    );
  }

  if (media?.media_status === MEDIA_STATUS.MEDIA_STATUS_DRAFT) {
    return (
      <>
        {renderStatusBadge(media, "draft", "Draft")}
        <FilterButton
          filterKey="media_status"
          filterValue={media?.media_status}
          displayText={
            mediaStatusToTextAndColor(media?.media_status || 0).statusText
          }
          filters={filters}
          updateIsFilter={updateIsFilter}
          updateIsClearFilter={updateIsClearFilter}
          handleSetFilters={handleSetFilters}
          toolTipText={undefined}
          dvk={dvk}
          filterDisplayName="Status"
          useContentEvent
        />
      </>
    );
  }

  if (media?.media_status === MEDIA_STATUS.MEDIA_STATUS_PUBLISHED) {
    if (activeType === DRIVE_TAB) {
      return (
        <>
          {renderStatusBadge(media, "ready", "Published")}
          <FilterButton
            filterKey="media_status"
            filterValue={media?.media_status}
            displayText={
              mediaStatusToTextAndColor(media?.media_status || 0).statusText
            }
            filters={filters}
            updateIsFilter={updateIsFilter}
            updateIsClearFilter={updateIsClearFilter}
            handleSetFilters={handleSetFilters}
            toolTipText="Filter by this Filter"
            dvk={dvk}
            filterDisplayName="Status"
          useContentEvent
          />
        </>
      );
    } else {
      return (
        <div
          className="d-flex flex-column"
          style={{ justifySelf: "flex-start" }}
        >
          <div>
            {renderStatusBadge(media, "ready", "Published")}
            <FilterButton
              filterKey="media_status"
              filterValue={media?.media_status}
              displayText={
                mediaStatusToTextAndColor(media?.media_status || 0).statusText
              }
              filters={filters}
              updateIsFilter={updateIsFilter}
              updateIsClearFilter={updateIsClearFilter}
              handleSetFilters={handleSetFilters}
              toolTipText="Filter by this Filter"
              dvk={dvk}
              filterDisplayName="Status"
          useContentEvent
            />
          </div>
          {renderCopyIdSection(media, styles)}
        </div>
      );
    }
  }

  // Default case for other statuses
  return (
    <div className={`d-flex align-items-center mt-2 ${styles["hover-filter"]}`}>
      <Tooltip content={mediaStatusTooltipText(media?.media_status || 0)}>
        <div className={`${statusInfo.statusColor} badge`}>
          {statusInfo.statusText}
        </div>
      </Tooltip>
      <FilterButton
        filterKey="media_status"
        filterValue={media?.media_status}
        displayText={
          mediaStatusToTextAndColor(media?.media_status || 0).statusText
        }
        filters={filters}
        updateIsFilter={updateIsFilter}
        updateIsClearFilter={updateIsClearFilter}
        handleSetFilters={handleSetFilters}
        toolTipText={undefined}
        dvk={dvk}
        filterDisplayName="Status"
          useContentEvent
      />
    </div>
  );
};

export default RenderStatus;
